import React from "react";
import { Link } from "react-router-dom";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="h-screen w-screen overflow-hidden grid md:grid-cols-2">
      {/* Form column — first in DOM so it shows on top on mobile */}
      <div className="flex items-center justify-center px-6 py-6 md:px-12 md:py-8 order-1" style={{ background: "#F4F4F0" }}>
        <div className="w-full max-w-md">
          <Link to="/" data-testid="back-home-link" className="label-eyebrow underline">← Back home</Link>
          <div className="label-eyebrow mt-4 text-neutral-600">Resume Studio</div>
          <h1 className="font-display text-4xl md:text-5xl uppercase mt-3 leading-[0.9] font-black">
            Sign in.<br/>Start drafting.
          </h1>
          <p className="mt-4 text-sm text-neutral-700">Use your Google account. No password, no forms, no email verification loops.</p>
          <button
            data-testid="google-sign-in-btn"
            onClick={handleGoogleLogin}
            className="mt-6 w-full brut-border brut-shadow bg-white px-6 py-3 flex items-center justify-center gap-3 font-medium"
          >
            <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            Continue with Google
          </button>
          <div className="mt-6 grid grid-cols-3 gap-2 label-eyebrow text-[10px] text-neutral-600">
            <div className="brut-border p-2 bg-white text-center">ATS-safe</div>
            <div className="brut-border p-2 bg-white text-center">AI drafts</div>
            <div className="brut-border p-2 bg-white text-center">PDF export</div>
          </div>
          <p className="mt-4 text-[11px] text-neutral-500">By continuing you agree to our terms. We never post to your account.</p>
        </div>
      </div>

      {/* Visual column — hidden on mobile so nothing scrolls */}
      <div className="hidden md:block relative order-2" style={{ borderLeft: "1px solid #0A0A0A" }}>
        <img
          src="https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsfGVufDB8fHx8MTc4NzQ5MzIzMHww&ixlib=rb-4.1.0&q=85"
          alt="architecture"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-6 left-6 right-6 bg-white brut-border p-5">
          <div className="label-eyebrow mb-1 text-neutral-600">Resume Studio</div>
          <div className="font-display text-2xl leading-tight">Design a resume that gets<br/>read, not skimmed.</div>
        </div>
      </div>
    </div>
  );
}
